import React from "react";
import { BackgroundType, ChatItemBorder } from "@fidget/common/components/chat/chatItemBorder";
import { observer } from "mobx-react";
import { DotLoader, DotStyleType } from "@fidget/common/components/loader/dotLoader";
import styles from "./typingIndicator.css";

export const TypingIndicator = observer(
  () => {
    return (
      <>
        <ChatItemBorder widgetStyle backgroundType={BackgroundType.AGENT}>
            <div className={styles.typing}>
              <DotLoader dotType={DotStyleType.WIDGET}/>
            </div>
        </ChatItemBorder>
      </>
      );
    }
);
